import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DataSourceService } from '../../service/data-source.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  readonly currentYear = new Date().getFullYear();

  constructor(readonly datasourceService: DataSourceService) {}
}
